<template>
  <div>
    <v-dialog v-model="dialogInfo" :max-width="max_width" scrollable @keydown.esc="closeModal">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>
          <slot></slot>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeModal()">{{ close_label }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "DialogInfo",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Información",
    },
    max_width: {
      type: [String, Number],
      default: 760,
    },
    close_label: {
      type: String,
      default: "Cerrar",
    },
  },
  computed: {
    dialogInfo: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("updateDialog", false);
    },
  },
};
</script>
